// services/userSaveWordApi.js

import axios from "axios";
import { makeRequest } from "../utils/handleJWT";
import { checkErrorMessage } from "../utils/responseHandler";

const SAVE_WORD_API_URL =
  "https://umlang.com/userSaveWord/api/v1/userSaveWord/saveWord";

/**
 * ذخیره لغت
 * @param {Object} params - پارامترهای ذخیره لغت
 */
export const saveWord = async (params) => {
  return makeRequest(async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await axios.post(
        SAVE_WORD_API_URL,
        {
          fromLang: params.fromLang,
          toLang: params.toLang,
          word: params.word,
          meanings: params.meanings || [],
          subtitle: params.subtitle || "",
          translateOfSubtitle: params.translateOfSubtitle || "",
          subtitleStartTime: params.subtitleStartTime || "",
          subtitleEndTime: params.subtitleEndTime || "",
          movieName: params.movieName || "",
          type: params.type || "word",
          season: params.season || "",
          episode: params.episode || "",
          groups: params.groups || [],
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        },
      );

      return {
        success: true,
        data: response.data,
      };
    } catch (error) {
      // خطای 402 رو جداگانه مدیریت می‌کنیم
      if (error.response?.status === 402) {
        throw error; // این خطا رو به بالا ارسال می‌کنیم تا جداگانه مدیریت بشه
      }

      const errorDetails = checkErrorMessage(error);
      return {
        success: false,
        error: errorDetails.message,
        status: errorDetails.status,
      };
    }
  });
};
